module.exports = __webpack_public_path__ + "static/img/newsucai.90e7ff22.png";